import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialogRef } from "@angular/material";

@Component({
	selector: "sdp-force-password-change",
	templateUrl: "./force-password-change.component.html",
})
export class ForcePasswordChangeComponent implements OnInit, OnDestroy {
	public resetPasswordForm: FormGroup;
	public errMessage = "";
	public isResetSubmitted = false;
	public passwordType = "password";
	public readonly lockIcon = { type: "material", name: "lock", cssClass: "sdp-force-password-icon" };
	public readonly passwordIcon = { type: "material", name: "remove_red_eye", cssClass: "sdp-force-password-click" };

	constructor(private formBuilder: FormBuilder, public dialogRef: MatDialogRef<ForcePasswordChangeComponent>) {
		this.resetPasswordForm = this.formBuilder.group({
			password: ["", undefined],
			oldPassword: ["", undefined]
		});
	}

	public ngOnInit() {
	}

	public ngOnDestroy() {
		this.isResetSubmitted = false;
	}

	public submit() {
		this.isResetSubmitted = true;
		this.dialogRef.close(this.resetPasswordForm.getRawValue().password);
	}
}
